import * as React from "react";
import {
    PlasmicProjectTitleEditor,
    DefaultProjectTitleEditorProps
} from "./plasmic/main/PlasmicProjectTitleEditor";
import {Project} from "../models/fauna/dbSchema";
import {useEffect, useState} from "react";

export interface ProjectTitleEditorProps extends DefaultProjectTitleEditorProps {
    entry?: Project,
    readonly: boolean,
    onChange: (entry: any) => void,
    onUpload: (entry: any) => void,
}

type EditingStatus = 'loading' | 'notStored' | 'editingName' | undefined;


function ProjectTitleEditor({entry, readonly, onChange, onUpload, ...rest}: ProjectTitleEditorProps) {
    const [editingStatus, setEditingStatus] = useState<EditingStatus>('loading');

    useEffect(() => {
        if (entry?.status === 'notStored') {
            setEditingStatus('notStored');
        } else if (entry?.status === 'uploading') {
            setEditingStatus('loading');
        } else {
            setEditingStatus(undefined);
        }
    }, [entry]);

    function finishNameEditing(name: string) {
        if (name !== entry?.name) {
            if (name === '') {
                name = 'Untitled'
            }
            onChange({...entry, name});
        }
        setEditingStatus(undefined);
    }

    return <PlasmicProjectTitleEditor
        root={{
            props: {
                onClick: () => {
                    if (readonly || editingStatus === 'loading') {
                        return;
                    } else if (editingStatus === 'notStored') {
                        onUpload(entry);
                    } else if (editingStatus === undefined) {
                        setEditingStatus('editingName');
                    }
                }
            }
        }}
        state={editingStatus}
        inputFiled={{
            defaultValue: entry?.name?entry?.name: '' ,
            onFinish: finishNameEditing,
            autoFocus: true,
            placeholder: 'Project Title',
            finishOnBlur: true
        }}
        {...rest} >
        {entry?.name}
    </PlasmicProjectTitleEditor>;
}

export default ProjectTitleEditor;
